import { render, staticRenderFns } from "./PostNewJob.vue?vue&type=template&id=811a61ba&scoped=true"
import script from "./PostNewJob.vue?vue&type=script&lang=ts"
export * from "./PostNewJob.vue?vue&type=script&lang=ts"
import style0 from "./PostNewJob.vue?vue&type=style&index=0&id=811a61ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811a61ba",
  null
  
)

export default component.exports